<template>
<div id="area_page">
    <div id="main">
        <div class="main-wrap" v-on:scroll.passive="scollPos($event)">
            <div class="rec-wrap">
                <vertical-list-component ref="vertical" />
            </div>
        </div>
    </div>
</div>
</template>

<script>
import VerticalListComponent from '../component/VerticalListComponent';

import * as config from '../../js/config';
import common from '../../js/common';
import EventBus from '../../js/event_bus';

export default {
    name: 'area_page',
    components: {
        'vertical-list-component': VerticalListComponent,
    },
    data() {
        return {
            params: {},
            scrollY: ''
        }
    },
    created() {
        EventBus.$on('set_params_area', (data) => {
            data.scrollY = this.scrollY; // 스크롤 데이터

            common.setParams(data);
            EventBus.$emit('detail-data', data);
            this.$router.push('/detail');
        });
    },
    mounted() {
        var getParams = common.getParams();
        var l_page = this.$store.getters['getLastPage'];
        if (l_page.value == "/detail") {
            setTimeout(function () {
                var el_chk = document.getElementById('elem_' + getParams.elem_index);
                if (el_chk != null) {
                    document.getElementById('elem_' + getParams.elem_index).scrollIntoView({
                        behavior: 'smooth'
                    });
                }
            }, 500);
        }

        if (getParams != null && getParams != 'undefined') {
            if (Object.keys(getParams).length !== 0) {
                this.params = getParams;
                this.initApp();
            }
        } else {
            this.params.area_code = '';
            this.params.city_id = '';
            this.params.town_id = '';
            this.initApp();
        }

        EventBus.$on('area-search-data', (data) => {
            this.params = data;
            this.initApp();
        });
    },
    methods: {
        initApp() {
            common.setLocationData((data) => {
                data.type = config.REQ_SEARCH_STORE_LIST;
                data.search_type = 'area';
                data.area_code = this.params.area_code;
                data.city_id = this.params.city_id;
                data.town_id = this.params.town_id;
                this.$refs.vertical.initComponent(data);
            });
        },
        scollPos(e) {
            this.scrollY = e.target.scrollTop;
        },
    },
    beforeDestroy() {
        // 이벤트버스 사용 후 해제 시켜줄 것 그렇지 않으면 객체가 쌓이는 현상이 발생
        EventBus.$off('area-search-data');
        EventBus.$off('set_params_area');
    }

}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/page/AreaPage.vue